import { isVideoCampaign } from '../../../../services/campaignDimension';
import { isVideoAccount } from '../../../account-management';

export const isVideoAccountAndDimension = ({ selectedAccount: { partnerTypes }, dimension, isRealtime }) =>
    isVideoAccount(partnerTypes) && isVideoCampaign(dimension) && !isRealtime;
